import { Option, Value } from 'baseui/select';
import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ActionType } from 'components/elements/table/type';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import useGetCruiseGroupDetailTableList from './table-column';
import {
  CruiseSaleCruiseSaleDetailsFormType,
  CruiseSaleFormType,
} from '../../form-type';

interface Props {
  parentIndex: number;
  cruiseRoomList: Option[];
}

export default function CruiseGuestDetailGroupedTable(props: Props) {
  const { editable } = useFormState();
  const { control, setValue, getValues, clearErrors } =
    useFormContext<CruiseSaleFormType>();

  const name = `cruiseSales.${props.parentIndex}.cruiseSaleDetails` as const;

  const detailValue = useWatch({
    control,
    name,
  });

  const columns = useGetCruiseGroupDetailTableList(props.cruiseRoomList);

  const dispatch = React.useCallback(
    (action) => {
      const details = getValues(name);
      const { customId, id, guestId, ...rest } = details[0];
      const columnId =
        action.columnId as keyof CruiseSaleCruiseSaleDetailsFormType;
      const extra = action.extra as Value;
      const type = action.type as ActionType;
      const value = action.value;

      const otherVal: () => Partial<CruiseSaleCruiseSaleDetailsFormType> =
        () => {
          if (columnId === 'cruiseRoomId') {
            return {
              cruiseRoomName: extra?.[0]?.label as string,
            };
          }
          return {};
        };

      if (type === 'update_cell') {
        const rowValue = {
          ...rest,
          [columnId]: value,
          ...otherVal(),
        };

        const _details = details.map((detail) => {
          return {
            ...detail,
            ...rowValue,
          };
        });
        setValue(name, _details);
        clearErrors(name);
      }
    },
    [clearErrors, getValues, name, setValue],
  );

  const detail = detailValue[0];
  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={detail ? [detail] : []}
        dispatch={dispatch}
        disabled={!editable}
        noAddRemoveRow
        name={name}
        uniqueRowKey="customId"
      />
      <SeparatorVertical $margin={12} />
    </div>
  );
}
